"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var Placeholder = function Placeholder(props) {
  // eslint-disable-next-line react/prop-types
  var selectProps = props.selectProps,
      innerProps = props.innerProps,
      children = props.children;
  return _react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    color: "textSecondary",
    variant: "body1",
    className: selectProps.classes.placeholder
  }, innerProps), children);
};

var _default = Placeholder;
exports["default"] = _default;